import { Analytics, CompareArrows, Grass, SpaceDashboard, Timeline, TipsAndUpdates, TravelExplore } from "@mui/icons-material";
import { routes } from "../pages/routes";
import { Icon } from "@iconify/react";
import { t } from "i18next";

export const sideBarEnum = (path: string) => ([
    {
        key: 'navbar:dashboard',
        icon: <Icon icon='bxs:dashboard' width={22} height={22}></Icon>,
        isExternal: false,
        path: routes.DASHBOARD_ROUTES.HOME,
        selected: isIncluded(['dashboard'], path),
        event_name: "DASHBOARD_MENU_ITEM_CLICKED"
    },
    {
        key: 'navbar:myTrainings',
        icon: <Icon icon='maki:racetrack-horse' width={22} height={22}></Icon>,
        isExternal: false,
        path: routes.DASHBOARD_ROUTES.TRAININGS,
        selected: isIncluded(['trainings', 'training'], path),
        event_name: "TRAININGS_MENU_ITEM_CLICKED"
    },
    {
        key: 'navbar:comparison',
        icon: <Icon icon='carbon:compare' width={22} height={22}></Icon>,
        isExternal: false,
        path: routes.DASHBOARD_ROUTES.COMPARAISON,
        selected: isIncluded(['compare'], path),
        event_name: "COMPARISON_MENU_ITEM_CLICKED"
    },
    {
        key: 'navbar:myStable',
        icon: <Icon icon='fa6-solid:horse-head' width={22} height={22}></Icon>,
        isExternal: false,
        path: routes.DASHBOARD_ROUTES.YARD,
        selected: isIncluded(['stable'], path),
        event_name: "YARD_MENU_ITEM_CLICKED"
    },
    {
        key: 'navbar:analytics',
        icon: <Icon icon='uil:analytics' width={22} height={22}></Icon>,
        isExternal: false,
        path: routes.DASHBOARD_ROUTES.ANALYTICS,
        selected: isIncluded(['analytics'], path),
        event_name: "ANALYTICS_MENU_ITEM_CLICKED"
    },
    {
        key: 'navbar:dataSuccess',
        icon: <Icon icon='solar:inbox-archive-linear' width={22} height={22}></Icon>,
        isExternal: false,
        path: routes.DASHBOARD_ROUTES.DATA_SUCCESS,
        selected: isIncluded(['data-success'], path),
        event_name: "PDF_ARCHIVE_MENU_ITEM_CLICKED"
    },
    {
        key: 'navbar:profileOptions:knowledgeBase',
        icon: <TipsAndUpdates></TipsAndUpdates>,
        isExternal: true,
        path: t('navbar:profileOptions:knowledgeBaseLink'),
        selected: false,
        event_name: "KNOWLEDGE_BASE_MENU_ITEM_CLICKED"
    },
    {
        key: 'navbar:profileOptions:blog',
        icon: <TravelExplore></TravelExplore>,
        isExternal: true,
        path: "https://arioneo.com/en/blog",
        selected: false,
        event_name: ""
    },
])

const isIncluded = (arr: string[], path: string) => {

    let included: boolean = false

    for (let index = 0; index < arr.length; index++) {

        if (path.includes(arr[index])) {
            return true
        }

    }

    return included

}